// Call review (D-112): the small decisions the review panel makes, kept here so they are tested.
import type { QaCheck, QaMe, QaStage } from "./types";

export type Answers = Record<string, boolean | undefined>;

/** A No on any check flags the call for the seniors, as does the reviewer's own flag (QA-03). */
export function isFlagged(answers: Answers, flag: boolean): boolean {
  return flag || Object.values(answers).some((v) => v === false);
}

/** Every check answered, Yes or No. */
export function allAnswered(checks: QaCheck[], answers: Answers): boolean {
  return checks.every((c) => typeof answers[c.key] === "boolean");
}

/** The first check after `from` (going round) that has no answer yet, or -1 when all are answered. */
export function nextUnanswered(checks: QaCheck[], answers: Answers, from: number): number {
  for (let i = 1; i <= checks.length; i++) {
    const j = (from + i) % checks.length;
    if (typeof answers[checks[j].key] !== "boolean") return j;
  }
  return -1;
}

/** Only answered checks are saved. */
export function answered(answers: Answers): Record<string, boolean> {
  return Object.fromEntries(Object.entries(answers).filter(([, v]) => typeof v === "boolean")) as Record<
    string,
    boolean
  >;
}

/** "•••• 6090": the customer's number as reviewers see it. */
export function maskedNumber(end: string | null): string {
  return end ? `•••• ${end}` : "Unknown number";
}

/** The stages a member can review at, theirs first: a tester's every call, a senior's flagged calls. */
export function stagesFor(me: QaMe): QaStage[] {
  if (me.qa_role === "tester") return ["tester"];
  if (me.qa_role === "senior") return me.can_manage ? ["senior", "tester"] : ["senior"];
  return me.can_manage ? ["tester", "senior"] : [];
}

export const stageLabel: Record<QaStage, string> = { tester: "Every call", senior: "Flagged calls" };
